import { AxiosResponse } from "axios";
import { ApiBrave } from "../../Apis/Brave";
import { IBancoDTO } from "../../types/banco";
import { IGetContaProps, IPageContaDTO } from "../../types/conta";
import { removeEmpty } from "../../utils/removeEmpty";

const basePath = "/conta";

export class Conta {
  static async get(
    props?: IGetContaProps
  ): Promise<AxiosResponse<IPageContaDTO>> {
    let params = "";
    if (props) {
      const values = removeEmpty(props);
      params = new URLSearchParams(values as any).toString();
    }
    return ApiBrave.get(params ? `${basePath}?${params}` : basePath);
  }
}
